import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M3 21h8a1 1 0 0 0 1-1v-1.5a1.5 1.5 0 0 0-1.5-1.5h-7A1.5 1.5 0 0 0 2 18.5V20a1 1 0 0 0 1 1m20-3a1.61 1.61 0 0 0 0-2.33l-6.81-6.14a.28.28 0 0 1-.09-.18.25.25 0 0 1 .08-.18l1.76-1.76a.26.26 0 0 1 .33 0 1.48 1.48 0 0 0 .9.3 1.53 1.53 0 0 0 1.06-.44 1.51 1.51 0 0 0 0-2.12L15.54.44a1.49 1.49 0 0 0-2.12 0 1.51 1.51 0 0 0-.14 2 .23.23 0 0 1 0 .32l-5.56 5.5a.23.23 0 0 1-.32 0 1.51 1.51 0 0 0-2 .14 1.49 1.49 0 0 0 0 2.12l4.68 4.69a1.5 1.5 0 0 0 2.26-2 .26.26 0 0 1 0-.33l1.76-1.76a.25.25 0 0 1 .18-.08.21.21 0 0 1 .18.09L20.67 18A1.61 1.61 0 0 0 23 18m-10.5 4h-11a1 1 0 0 0 0 2h11a1 1 0 0 0 0-2"
    }, null, -1)
  ]));
}
const legalJusticeHammerGavel = { render };
export {
  legalJusticeHammerGavel as default,
  render
};
//# sourceMappingURL=legal-justice-hammer-gavel.svg.js.map
